import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SistemaDefensivoInfografia = () => {
  const [selectedLayer, setSelectedLayer] = useState(null);

  const layers = [
    {
      id: 'espacial',
      name: 'Capa Espacial',
      icon: '🛰️',
      color: '#8b5cf6',
      height: '15%',
      description: 'Satélites de vigilancia, comunicaciones y sistemas de alerta temprana',
      capabilities: [
        'Detección de lanzamientos de misiles',
        'Comunicaciones seguras globales',
        'Navegación GPS/GLONASS',
        'Reconocimiento e inteligencia'
      ],
      threats: ['Misiles antisatélite (ASAT)', 'Armas láser', 'Guerra electrónica espacial']
    },
    {
      id: 'estratosfera',
      name: 'Capa Estratosférica',
      icon: '✈️',
      color: '#3b82f6',
      height: '15%',
      description: 'Interceptores de largo alcance y sistemas de defensa antimisiles balísticos',
      capabilities: [
        'Interceptores THAAD (Terminal High Altitude)',
        'Sistema Aegis BMD',
        'Misiles SM-3',
        'Defensa contra ICBMs'
      ],
      threats: ['Misiles balísticos intercontinentales', 'Vehículos hipersónicos']
    },
    {
      id: 'alta',
      name: 'Capa Aérea Alta',
      icon: '🚀',
      color: '#0ea5e9',
      height: '15%',
      description: 'Defensa contra misiles de medio alcance y amenazas aéreas de alta altitud',
      capabilities: [
        'Patriot PAC-3',
        'S-400 Triumf',
        'Arrow 3',
        'Defensa contra misiles de teatro'
      ],
      threats: ['Misiles balísticos de medio alcance', 'Bombarderos estratégicos']
    },
    {
      id: 'media',
      name: 'Capa Aérea Media',
      icon: '🛩️',
      color: '#06b6d4',
      height: '15%',
      description: 'Defensa contra aeronaves, drones y misiles de crucero',
      capabilities: [
        'Cazas de superioridad aérea (F-22, Su-57)',
        'Sistemas SAM de medio alcance',
        'AWACS y control aéreo',
        'Defensa contra drones'
      ],
      threats: ['Cazas enemigos', 'Misiles de crucero', 'Drones de combate']
    },
    {
      id: 'baja',
      name: 'Capa Aérea Baja',
      icon: '🎯',
      color: '#10b981',
      height: '15%',
      description: 'Defensa de punto y protección de objetivos críticos',
      capabilities: [
        'Iron Dome',
        'Pantsir-S1',
        'C-RAM (Counter Rocket, Artillery, Mortar)',
        'Sistemas láser (Iron Beam)'
      ],
      threats: ['Cohetes', 'Morteros', 'Artillería', 'Drones pequeños']
    },
    {
      id: 'terrestre',
      name: 'Capa Terrestre',
      icon: '🏰',
      color: '#22c55e',
      height: '15%',
      description: 'Defensa física, fortificaciones y sistemas de protección pasiva',
      capabilities: [
        'Bunkers y refugios',
        'Sistemas de camuflaje',
        'Contramedidas electrónicas',
        'Defensa cibernética'
      ],
      threats: ['Fuerzas terrestres', 'Sabotaje', 'Ciberataques', 'Infiltración']
    },
    {
      id: 'cibernetica',
      name: 'Capa Cibernética',
      icon: '💻',
      color: '#eab308',
      height: '10%',
      description: 'Defensa de infraestructura digital y sistemas de comando y control',
      capabilities: [
        'Firewalls militares',
        'Detección de intrusiones',
        'Contramedidas ofensivas',
        'Protección de comunicaciones'
      ],
      threats: ['Malware', 'APTs', 'DDoS', 'Guerra de información']
    }
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f172a',
      padding: '2rem',
      color: '#f1f5f9'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Botón de navegación superior */}
        <div style={{ marginBottom: '2rem' }}>
          <Link 
            to="/" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.75rem 1.5rem',
              background: 'rgba(59, 130, 246, 0.1)',
              border: '1px solid rgba(59, 130, 246, 0.3)',
              borderRadius: '0.5rem',
              color: '#3b82f6',
              textDecoration: 'none',
              fontSize: '1rem',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
              e.currentTarget.style.transform = 'translateX(-5px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
              e.currentTarget.style.transform = 'translateX(0)';
            }}
          >
            ← Volver al Inicio
          </Link>
        </div>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            fontWeight: 'bold',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            🛡️ Sistema Defensivo Integrado
          </h1>
          <p style={{ color: '#94a3b8', fontSize: '1.2rem' }}>
            Arquitectura de Defensa en Capas del Siglo XXI
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem' }}>
          {/* Visualización de Capas */}
          <div style={{
            background: 'rgba(30, 41, 59, 0.8)',
            borderRadius: '1rem',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            padding: '2rem',
            height: '800px',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <h2 style={{ fontSize: '1.5rem', marginBottom: '2rem', textAlign: 'center' }}>
              Capas Defensivas
            </h2>
            
            <div style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: '0.5rem',
              position: 'relative'
            }}>
              {layers.map((layer, index) => (
                <div
                  key={layer.id}
                  onClick={() => setSelectedLayer(layer)}
                  style={{
                    height: layer.height,
                    background: `linear-gradient(135deg, ${layer.color} 0%, ${layer.color}dd 100%)`,
                    borderRadius: '0.5rem',
                    padding: '1rem',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: selectedLayer?.id === layer.id ? '3px solid #fbbf24' : '1px solid rgba(255,255,255,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.02)';
                    e.currentTarget.style.boxShadow = `0 0 20px ${layer.color}80`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', zIndex: 1 }}>
                    <span style={{ fontSize: '2rem' }}>{layer.icon}</span>
                    <div>
                      <h3 style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.25rem' }}>
                        {layer.name}
                      </h3>
                      <p style={{ fontSize: '0.8rem', opacity: 0.9 }}>
                        {layer.description}
                      </p>
                    </div>
                  </div>
                  
                  {/* Indicador de altitud */}
                  <div style={{
                    position: 'absolute',
                    right: '1rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '3rem',
                    opacity: 0.2,
                    fontWeight: 'bold'
                  }}>
                    {layers.length - index}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Panel de Detalles */}
          <div style={{
            background: 'rgba(30, 41, 59, 0.8)',
            borderRadius: '1rem',
            border: '1px solid rgba(148, 163, 184, 0.2)',
            padding: '2rem',
            height: '800px',
            overflow: 'auto'
          }}>
            {selectedLayer ? (
              <div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  marginBottom: '2rem',
                  paddingBottom: '1rem',
                  borderBottom: `3px solid ${selectedLayer.color}`
                }}>
                  <span style={{ fontSize: '3rem' }}>{selectedLayer.icon}</span>
                  <div>
                    <h2 style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                      {selectedLayer.name}
                    </h2>
                    <p style={{ color: '#94a3b8' }}>{selectedLayer.description}</p>
                  </div>
                </div>

                {/* Capacidades */}
                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    color: selectedLayer.color
                  }}>
                    ⚡ Capacidades
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {selectedLayer.capabilities.map((cap, idx) => (
                      <div key={idx} style={{
                        background: 'rgba(15, 23, 42, 0.8)',
                        padding: '1rem',
                        borderRadius: '0.5rem',
                        borderLeft: `4px solid ${selectedLayer.color}`
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ color: selectedLayer.color, fontSize: '1.2rem' }}>✓</span>
                          <span>{cap}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Amenazas */}
                <div>
                  <h3 style={{
                    fontSize: '1.3rem',
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    color: '#ef4444'
                  }}>
                    ⚠️ Amenazas
                  </h3>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                    {selectedLayer.threats.map((threat, idx) => (
                      <div key={idx} style={{
                        background: 'rgba(239, 68, 68, 0.1)',
                        padding: '1rem',
                        borderRadius: '0.5rem',
                        borderLeft: '4px solid #ef4444'
                      }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span style={{ color: '#ef4444', fontSize: '1.2rem' }}>⚠</span>
                          <span>{threat}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                color: '#64748b'
              }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>👈</div>
                <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                  Selecciona una Capa
                </h3>
                <p>Haz clic en cualquier capa para ver sus detalles</p>
              </div>
            )}
          </div>
        </div>

        {/* Leyenda */}
        <div style={{
          marginTop: '2rem',
          background: 'rgba(30, 41, 59, 0.8)',
          borderRadius: '1rem',
          border: '1px solid rgba(148, 163, 184, 0.2)',
          padding: '2rem'
        }}>
          <h3 style={{ fontSize: '1.3rem', marginBottom: '1rem', textAlign: 'center' }}>
            📊 Principios del Sistema Integrado
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1rem'
          }}>
            <div style={{
              background: 'rgba(15, 23, 42, 0.8)',
              padding: '1rem',
              borderRadius: '0.5rem',
              borderLeft: '4px solid #3b82f6'
            }}>
              <h4 style={{ color: '#3b82f6', marginBottom: '0.5rem' }}>🔄 Redundancia</h4>
              <p style={{ fontSize: '0.9rem', color: '#94a3b8' }}>
                Múltiples capas aseguran que si una falla, otras continúan protegiendo
              </p>
            </div>
            <div style={{
              background: 'rgba(15, 23, 42, 0.8)',
              padding: '1rem',
              borderRadius: '0.5rem',
              borderLeft: '4px solid #8b5cf6'
            }}>
              <h4 style={{ color: '#8b5cf6', marginBottom: '0.5rem' }}>⚡ Integración</h4>
              <p style={{ fontSize: '0.9rem', color: '#94a3b8' }}>
                Todas las capas comparten información en tiempo real
              </p>
            </div>
            <div style={{
              background: 'rgba(15, 23, 42, 0.8)',
              padding: '1rem',
              borderRadius: '0.5rem',
              borderLeft: '4px solid #10b981'
            }}>
              <h4 style={{ color: '#10b981', marginBottom: '0.5rem' }}>🎯 Especialización</h4>
              <p style={{ fontSize: '0.9rem', color: '#94a3b8' }}>
                Cada capa está optimizada para amenazas específicas
              </p>
            </div>
          </div>
        </div>

        {/* Navegación inferior */}
        <div style={{
          marginTop: '3rem',
          padding: '2rem',
          background: 'rgba(30, 41, 59, 0.8)',
          borderRadius: '1rem',
          border: '1px solid rgba(148, 163, 184, 0.2)'
        }}>
          <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem', textAlign: 'center' }}>
            📚 Explora Más Contenido
          </h3>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '1rem'
          }}>
            <Link
              to="/seguridad-nacional-2025"
              style={{
                padding: '1rem',
                background: 'rgba(59, 130, 246, 0.1)',
                border: '1px solid rgba(59, 130, 246, 0.3)',
                borderRadius: '0.5rem',
                color: '#3b82f6',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              🎯 Estrategia 2025
            </Link>
            <Link
              to="/seguridad-nacional-analisis"
              style={{
                padding: '1rem',
                background: 'rgba(139, 92, 246, 0.1)',
                border: '1px solid rgba(139, 92, 246, 0.3)',
                borderRadius: '0.5rem',
                color: '#8b5cf6',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(139, 92, 246, 0.2)';
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(139, 92, 246, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              📊 Análisis Crítico
            </Link>
            <Link
              to="/"
              style={{
                padding: '1rem',
                background: 'rgba(16, 185, 129, 0.1)',
                border: '1px solid rgba(16, 185, 129, 0.3)',
                borderRadius: '0.5rem',
                color: '#10b981',
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(16, 185, 129, 0.2)';
                e.currentTarget.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(16, 185, 129, 0.1)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              🏠 Inicio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SistemaDefensivoInfografia;
